module.exports = __webpack_public_path__ + "a6efc4620b4483783e9afc096e120977.png";


//////////////////
// WEBPACK FOOTER
// ./directives/appCard/visa-electron.png
// module id = 941
// module chunks = 0